module.exports = new __parcel__URL__("lock-red.d0e5588b.svg").toString();